import React, { useEffect, useContext,  useState } from 'react';
import { toast } from 'react-toastify';
import useWarehouseOrderExpeditionService from '../../../../app/services/hooks/useWareHouseOrderExpedition';
import { WarehouseOrderExpeditionDataForm, WarehouseOrderExpeditionFilters, WarehouseOrderExpeditionShowDataForm } from '../../../../app/models/WareHouseOrderExpedition';
import { AppContext } from '../../../../contexts/AppContext';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../../hooks/useReactConfirmAlert';
import DefaultCard from '../../../../components/default/DefaultCard';
import DefaultToolBar from '../../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../../components/buttons/ButtonCreate';
import WarehouseExpeditionDataTable from '../../../Quotes/subpages/WareHouseQuote/components/tables/WarehouseQuoteExpeditionDataTable';
import DefaultModal from '../../../../components/default/DefaultModal';
import WarehouseOrderExpeditionCreate from '../WarehouseOrderExpeditionCreate';
import WarehouseOrderExpeditionEdit from '../WarehouseOrderExpeditionEdit';
import WarehouseOrderExpeditionShow from '../WarehouseOrderExpeditionShow';





interface Props {
    warehouseOrderId: number;
    // expeditions: WarehouseOrderExpeditionDataForm;
    disableUpdate?: boolean;
    refresh?: number;
    isFormShow?: boolean;
}

const WarehouseOrderExpeditionContainer = ({
    warehouseOrderId,
    disableUpdate = false,
    isFormShow = false,
    refresh
}: Props) => {
    const {
        getWarehouseOrderExpedition,
        getAllWarehouseOrderExpeditionsByOrder,
        updateWarehouseOrderExpedition,
        deleteWarehouseOrderExpedition,
        fetchingGetWarehouseOrderExpedition,
        fetchingUpdateWarehouseOrderExpedition
    } = useWarehouseOrderExpeditionService();

    const [expeditionData, setExpeditionData] = useState<WarehouseOrderExpeditionDataForm>({
        container_type: ''
    });

    const [warehouseOrderExpedition, setWarehouseOrderExpedition] = useState<WarehouseOrderExpeditionShowDataForm[]>([]);
    const [WarehouseOrderExpeditionIdEdit, setWarehouseOrderExpeditionIdEdit] = useState<number>(-1);
    const [WarehouseOrderExpeditionIdCreate, setWarehouseOrderExpeditionIdCreate] = useState<number>(-1);
    const [WarehouseOrderExpeditionIdShow, setWarehouseOrderExpeditionIdShow] = useState<number>(-1);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseOrderExpeditionFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });
    const [showingCreate, setShowingCreate] = useState(false);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);

    useEffect(() => {
        if (warehouseOrderId) reloadTable();
    }, [warehouseOrderId, filter,refresh]);

    const reloadTable = () => {
        getAllWarehouseOrderExpeditionsByOrder(warehouseOrderId, filter, {
            onSuccess: (response: ServiceResponse) => {
                setWarehouseOrderExpedition(response.data.warehouse_order_expeditions);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };
    const show =  (id: number) => {
        setShowingShow(true);
        setWarehouseOrderExpeditionIdShow(id);

    };

    const showEdit = (id: number) => {
        setShowingEdit(true);
        setWarehouseOrderExpeditionIdEdit(id);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setWarehouseOrderExpeditionIdEdit(-1);
    };

    const hideShow = () => {
        setShowingShow(false);
        setWarehouseOrderExpeditionIdShow(-1);
    };

    const hideCreate = () => {
        setShowingCreate(false);
        setWarehouseOrderExpeditionIdCreate(-1);
    };


    const create = () => {
        setShowingCreate(true);
    };

    const update = () => {
        updateWarehouseOrderExpedition(warehouseOrderId, expeditionData, {
            onSuccess: (response: ServiceResponse) => {
                toast.success(response.message);
                setShowingCreate(false);
                setShowingEdit(false);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };
    const destroy = (id: number) => {
        const message = `Está a punto de eliminar la expediíon #${id}`;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: message,
            buttons: {
                confirmButton: {
                    label: 'Sí, eliminar',
                    onClick: () => {
                        if (showLoading)
                            showLoading('loading', 'Eliminando tarifa...');

                        deleteWarehouseOrderExpedition(id, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'La tarifa no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };


    

    return (
        <>
        <DefaultCard>
            <div className="h3 mt-0 mb-4 card-title">Expedición</div> 
            <div className="row">
                <div className="col-12">
                    {!disableUpdate && (
                        <DefaultToolBar left={<ButtonCreate callbackCreate={() => setShowingCreate(true)} />} />
                    )}
                </div>
                <div className="col-12">
                    <WarehouseExpeditionDataTable
                        warehouseQuoteExpeditions={warehouseOrderExpedition}
                        totalRows={totalRows}
                        loading={fetchingGetWarehouseOrderExpedition}
                        show={show}
                        // edit={showEdit}
                        destroy={destroy}
                        filter={filter}
                        setFilter={setFilter}
                        isShow={isFormShow}

                    />
                </div>
            </div>
        </DefaultCard>


            <DefaultModal
                show={showingCreate}
                handleClose={hideCreate}
                title="Crear Expedición"
                showFooter={false}
            >
                <WarehouseOrderExpeditionCreate
                    warehouseOrderId={warehouseOrderId}
                    onSaved={() => {
                        reloadTable();
                        setShowingCreate(false);
                    }}
                    onCancel={() => setShowingCreate(false)}
                />
            </DefaultModal>

       {showingEdit ?(
            <DefaultModal
                show={showingEdit}
                handleClose={hideEdit}
                title="Editar Expedición"
                showFooter={false}
            >
                <WarehouseOrderExpeditionEdit
                    expeditionId={WarehouseOrderExpeditionIdEdit}
                    onSaved={() => {
                        reloadTable();
                        setShowingEdit(false);
                    }}
                    onCancel={hideEdit}
                />
            </DefaultModal>
            ) : null}

        {showingShow ? (
            <DefaultModal
                show={showingShow}
                handleClose={hideShow}
                title="Ver información expedicion"

            >
                <WarehouseOrderExpeditionShow 
                    expeditionId={WarehouseOrderExpeditionIdShow} 
                    onCancel={hideShow} 
                />
            </DefaultModal>
            ) : null}


        </>
    );
};

export default WarehouseOrderExpeditionContainer;
